module.exports = __webpack_public_path__ + "chat-icon.e0d2b748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat-icon.svg
// module id = ozN6
// module chunks = 0